import { useState, useEffect } from "react";

export default function useDynamicPixelOffset(
  map,
  markerPosition,
  margin = 150,
) {
  const [offset, setOffset] = useState({ x: 0, y: -40 });

  useEffect(() => {
    if (!map || !markerPosition) return;

    //const timeout = setTimeout(() => {
    const bounds = map.getBounds();
    const mapDiv = map.getDiv();

    if (!bounds || !mapDiv) return;

    const mapWidth = mapDiv.offsetWidth;
    const mapHeight = mapDiv.offsetHeight;

    const sw = bounds.getSouthWest();
    const ne = bounds.getNorthEast();

    const lat = markerPosition.lat;
    const lng = markerPosition.lng;

    // Calcolo percentuale orizzontale e verticale
    const xRatio = (lng - sw.lng()) / (ne.lng() - sw.lng());
    const yRatio = (ne.lat() - lat) / (ne.lat() - sw.lat());

    const posX = Math.round(xRatio * mapWidth);
    const posY = Math.round(yRatio * mapHeight);

    console.log(posX, posY, margin);

    const infoWindowWidth = 250;
    const infoWindowHeight = 330;

    let offsetX = 0;
    let offsetY = -40; // default

    // Orizzontale
    if (posX < margin + infoWindowWidth / 2) {
      offsetX = margin;
    } else if (posX > mapWidth - margin - infoWindowWidth / 2) {
      offsetX = -margin;
    }

    // Verticale
    if (posY < margin + infoWindowHeight) {
      offsetY = margin;
    } else if (posY > mapHeight - margin - infoWindowHeight) {
      console.log("Siamo qui 2");
      offsetY = -margin;
    } else {
      console.log("Siamo qui 3");
    }

    let fixedOffsetY = 0;

    console.log(offsetX, offsetY);

    if (offsetX === 0) {
      fixedOffsetY = offsetY - 30;
    } else if (offsetY === offsetX) {
      fixedOffsetY = offsetY + 150;
    } else if (offsetY === -offsetX) {
      fixedOffsetY = offsetY + 150;
    } else {
      fixedOffsetY = offsetY;
    }

    console.log(offsetX, fixedOffsetY);

    setOffset({ x: offsetX, y: fixedOffsetY });
    //}, 5); // aspetta che la mappa si stabilizzi

    //return () => clearTimeout(timeout);
  }, [map, markerPosition, margin]);

  return offset;
}
